export default "__VITE_ASSET__B3z_VwSP__"